<template>
  <div class="page-container">
    <div>
      <section id="send-form">
        <form
          class="md-layout text-center col-11 mx-auto"
          @submit.prevent="validate"
        >
          <md-card class="form">
            <md-card-header class="p-2">
              <h4 class="mt-2">パスワード再設定案内</h4>
            </md-card-header>
            <md-card-content>
              <div class="md-layout md-gutter mt-3">
                <div class="md-layout-item">
                  <input
                    type="text"
                    :class="[
                      'form-control',
                      { 'border-red': $v.form.USER_ID.$error },
                    ]"
                    @change="$v.form.USER_ID.$touch()"
                    v-model="form.USER_ID"
                    :maxlength="20"
                    placeholder="ID"
                  />
                  <div v-if="$v.form.USER_ID.$error" class="err-message">
                    <p v-if="!$v.form.USER_ID.required">入力必須です</p>
                  </div>
                </div>
              </div>
              <md-button
                class="md-raised"
                type="submit"
                :disabled="!isSendAble"
              >
                メール送信
              </md-button>
              <div class="text-left">
                <p class="mt-2">
                  ※アカウントのメールアドレス宛にパスワード再設定の案内メールを通知いたします。
                </p>
                <p class="mt-2 mt-md-0">
                  ※IDをお忘れの場合は弊社までお問い合わせください。
                </p>
              </div>
              <p class="my-2">
                <router-link to="/">
                  <a>ログイン画面にもどる</a>
                </router-link>
              </p>
            </md-card-content>
          </md-card>
        </form>
      </section>

      <p class="text-center">
        <router-link to="/kiyaku">
          <a>サイト利用規約</a>
        </router-link>
      </p>
    </div>

    <!-- メール送信完了 -->
    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isSent"
      md-content="<strong>メールを送信しました。</strong>"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import Mixin from '../mixin/Mixin'
import { required } from 'vuelidate/lib/validators'
import Valid from '@/valid'

const isEmoji = (value) => Valid.isEmoji(value)

export default {
  name: 'Index',
  mixins: [validationMixin, Mixin],
  data: () => ({
    isSent: false,
    form: {
      USER_ID: null,
    },
    isValidationClass: {
      USER_ID: null,
    },
    invalid: false,
  }),
  validations: {
    form: {
      USER_ID: {
        required,
        isEmoji,
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.auth.token
    },
    isSendAble() {
      return this.form.USER_ID && !this.$v.$invalid
    },
  },
  methods: {
    sendPasswordForget() {
      this.spinerOn()
      return this.$store
        .dispatch('password/forget', this.form)
        .then((res) => {
          this.isSent = true
          this.$v.$reset()
          this.form.USER_ID = ''
          this.spinerOff()
        })
        .catch((err) => {
          this.spinerOff()
          this._alert(err.message, false)
        })
    },
    validate() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.invalid = false
      } else {
        this.invalid = true
        this.spinerOff()
        return
      }
      this.sendPasswordForget()
    },
  },
  created: function () {
    if (this.$store.state.auth.token) {
      this.$router.push('Home')
    }
  },
  watch: {
    token(newToken) {
      this.$router.push('Home')
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
section#send-form
  .md-card-header
    background: $baseBlueColor
    color: white
  .form
    width: 50%
    margin: 40px auto
    @include sp
      width: 100%
      margin: 10px auto
  .md-button
    @extend.base-btn
    @extend.f-size-16
    background: $baseGreenColor
    border-radius: 5px
#apply-modal
  @extend .base_modal
  width: $baseWidth * 0.6
  .modal-note
    @extend.red
    margin-left: 13%
.err-message
  p
    text-align: left
</style>



// WEBPACK FOOTER //
// src/components/password/Index.vue